import { FunctionComponent as F } from 'react';
import { Button as MuiButton, SxProps, Theme } from '@mui/material';
import classes from './Button.module.css';

interface Props
{
  id?: string;
  label: string;
  onClick?: () => void;
  startIcon?: any;
  size?: 'medium' | 'large';
  type?: 'primary' | 'secondary';
  disabled?: boolean,
  sx?: SxProps<Theme>,
  color?: "primary" | "secondary" | "inherit" | "success" | "error" | "info" | "warning"
}

const Button: F<Props> = (props: Props) =>
{
  const type = props.type ? classes[props.type] : classes.primary;
  const size = props.size ? classes[props.size] : classes.large;

  return (
    <MuiButton
      id={props.id}
      variant='contained'
      size='small'
      color={props.color || 'primary'}
      sx={{ fontSize: 11, ml: 1, mr: 1, ...props.sx }}
      startIcon={props.startIcon}
      onClick={props.onClick}
      disabled={props.disabled}>
      {props.label}
    </MuiButton>);
};

export default Button;
